<template>
  <div class="offer-card">
    <div class="offer-small-card">
      <img :src="offerData.image" alt="" />

      <div class="product-detail">
        <div class="discount-number">
          <p>میزان تخفیف</p>
          <span>
            <p class="product-code-value">%{{ offerData.discount }}</p>
          </span>
        </div>

        <p class="product-name">{{ offerData.sellerName }}</p>

        <p class="product-price">
          {{ offerData.title }}
        </p>
        <button
          class="more-btn"
          @click="
            {
              offerDetails = !offerDetails;
            }
          "
        >
          بیشتر
        </button>
      </div>
    </div>
    <transition name="fade">
      <div class="offer-details" v-if="offerDetails == true">
        <div class="details-items">
          <div class="data-item">
            <p>مناسبت تخفیف:</p>
            <p class="data-item-value">{{ offerData.title }}</p>
          </div>
          <div class="data-item">
            <p>مهلت تخفیف:</p>
            <p class="data-item-value">{{ offerData.validityDuration }}</p>
          </div>
          <div class="data-item">
            <p>توضیحات:</p>
            <p class="data-item-value">{{ offerData.discription }}</p>
          </div>
        </div>
        <div class="link-div">
          <router-link
            class="witrino-link-btn"
            :to="
              '/' +
              offerData.witrinoId +
              '/products/' +
              offerData.sellerWitrinoCode
            "
          >
            فالیزنت
          </router-link>
          <router-link
            class="polotik-link-btn"
            :to="
              '/' +
              offerData.witrinoId +
              '/products/' +
              offerData.sellerWitrinoCode
            "
            >پلُ تیک</router-link
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "offerCard",
  props: {
    offerData: Object,
  },
  data() {
    return { offerDetails: false };
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/offerCard/offerCard.css);
</style>